import imgLogo from "@/assets/ig-logo-2.png";
import { FaUser } from "react-icons/fa6";

export const Logo = {
  Default: () => (
    <div className="flex flex-col items-center space-y-1 my-3">
      <div className="relative bg-gradient-to-tr from-[#FCAF45] via-[#FD1D1D] to-[#833AB4] p-1 rounded-full">
        <a
          href="#"
          className="block bg-black p-3 rounded-full transform transition hover:-rotate-6"
        >
          <img src={imgLogo} alt="Logo" className="w-16 h-16" />
        </a>
      </div>
    </div>
  ),

  Profile: ({ profilePicUrl }: { profilePicUrl: string }) => (
    <div className="mt-8 relative flex justify-center max-w-md mx-auto w-full">
      <div className="bg-black border-4 border-transparent rounded-full p-0.5 z-10 relative before:content-[''] before:absolute before:inset-0 before:rounded-full before:-z-10 before:bg-gradient-to-br before:from-[#833AB4] before:via-[#FD1D1D] before:to-[#FCAF45] before:p-0.5 before:-m-0.5">
        <img
          src={profilePicUrl}
          alt="Profile"
          className="w-20 h-20 rounded-full"
        />
      </div>
    </div>
  ),

  Loading: () => (
    <div className="flex flex-col items-center space-y-1 my-3">
      <div className="relative bg-gradient-to-tr from-[#FCAF45] via-[#FD1D1D] to-[#833AB4] p-1 rounded-full animate-pulse">
        <div className="block bg-black p-3 rounded-full">
          <div className="w-16 h-16 relative">
            <div className="absolute inset-2 rounded-full border-4 border-orange-300 border-t-transparent border-r-orange-400 border-b-transparent border-l-orange-400 animate-[spin_3s_ease-in-out_infinite]"></div>
            <div className="absolute inset-0 flex items-center justify-center">
              <FaUser className="text-orange-500 text-2xl" />
            </div>
          </div>
        </div>
      </div>
    </div>
  ),

  ProfileLoading: ({ profilePicUrl }: { profilePicUrl: string }) => (
    <div className="mt-8 relative flex justify-center max-w-md mx-auto w-full">
      <div className="bg-black border-4 border-transparent rounded-full p-0.5 z-10 relative before:content-[''] before:absolute before:inset-0 before:rounded-full before:-z-10 before:bg-gradient-to-br before:from-[#833AB4] before:via-[#FD1D1D] before:to-[#FCAF45] before:p-0.5 before:-m-0.5 before:animate-pulse">
        <img
          src={profilePicUrl}
          alt="Profile"
          className="w-20 h-20 rounded-full opacity-70"
        />
        <div className="absolute inset-0 flex items-center justify-center">
          <div className="absolute inset-2 rounded-full border-4 border-orange-400 border-t-transparent animate-[spin_1.5s_linear_infinite]"></div>
        </div>
      </div>
    </div>
  ),
};
